import type { RouteObject } from "react-router";

import { Outlet } from "react-router";
import { Suspense } from "react";

import { AuthSplitLayout } from "src/layouts/auth-split";

import { SplashScreen } from "src/components/loading-screen";

import { JwtSignInView } from "src/auth/view/jwt";
import PublicRoute from "src/auth/guard/public-route";

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */

const authJwt = {
  path: "/",
  element: <Outlet />,
  children: [
    {
      path: "login",
      element: (
        <AuthSplitLayout>
          <JwtSignInView />
        </AuthSplitLayout>
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <PublicRoute>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </PublicRoute>
    ),
    children: [authJwt],
  },
];
